module.exports = __webpack_public_path__ + "img/news.51db0b94.jpg";